<div [attr.data-comp]="'Filters'" class="content content-md">
  <div class="scroll-content scroll-content--no-search">
    @for (filter of filtersService.filterList; track filter) {
      <app-filters-item [onClick]="onClick" [config]="filter" />
    }
  </div>
</div>
